export function truncateErrorString(msg: string): string {
  if (msg.length > 60) {
    return msg.slice(0, 57) + '...'
  } else {
    return msg
  }
}
